import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgItalic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 19,
			x2: 10,
			y1: 4,
			y2: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 14,
			x2: 5,
			y1: 20,
			y2: 20
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 15,
			x2: 9,
			y1: 4,
			y2: 20
		})
	]
});
export default SvgItalic;
